import { Referrer } from '../../../interfaces';
import { GoogleClient } from '../../infrastructure/clients/google/google-client';
import { GoogleYoloResult } from '../../infrastructure/clients/google/types';
import { IStudentSignResult } from '../../infrastructure/clients/studentapi/interfaces/student-sign-result.interface';
import { StudentApiClient } from '../../infrastructure/clients/studentapi/student-api-client';
import { GoogleButtonSize } from '../enums/google-button-size';

export class GoogleProvider {
	constructor(
		private googleClient: GoogleClient,
		private studentAPIClient: StudentApiClient,
	) {}

	public async login(payload: object = {}, idToken: string): Promise<IStudentSignResult> {
		return await this.studentAPIClient.signIn({ google: idToken }, payload);
	}

	public async showYolo(): Promise<GoogleYoloResult> {
		return this.googleClient.showYolo();
	}

	public renderGoogleButton(options: { element: any; template: string, gButtonSize?: GoogleButtonSize }, referrer: Referrer | null): void {
		void this.googleClient.renderGoogleButton(options, referrer);
	}
}